import * as React from 'react';

const SCROLL_EDGE_TOLERANCE_PX = 1;
const LEFT_PINNED_OVERLAP_CLASS = 'autone-grid-has-left-pinned-overlap';
const RIGHT_PINNED_OVERLAP_CLASS = 'autone-grid-has-right-pinned-overlap';

export const usePinnedOverlapStyles = (
  rootRef: React.RefObject<HTMLDivElement>,
) => {
  const updatePinnedOverlapStyles = React.useCallback(() => {
    const rootElement = rootRef.current;
    if (!rootElement) return;

    const maxScrollLeft = Math.max(
      rootElement.scrollWidth - rootElement.clientWidth,
      0,
    );

    rootElement.classList.toggle(
      LEFT_PINNED_OVERLAP_CLASS,
      rootElement.scrollLeft > SCROLL_EDGE_TOLERANCE_PX,
    );
    rootElement.classList.toggle(
      RIGHT_PINNED_OVERLAP_CLASS,
      rootElement.scrollLeft < maxScrollLeft - SCROLL_EDGE_TOLERANCE_PX,
    );
  }, [rootRef]);

  React.useLayoutEffect(() => {
    const rootElement = rootRef.current;
    if (!rootElement) return;

    updatePinnedOverlapStyles();
    rootElement.addEventListener('scroll', updatePinnedOverlapStyles, {
      passive: true,
    });

    return () => {
      rootElement.removeEventListener('scroll', updatePinnedOverlapStyles);
    };
  }, [rootRef, updatePinnedOverlapStyles]);

  return {
    updatePinnedOverlapStyles,
  };
};
